import { render, staticRenderFns } from "./RatingDialog.vue?vue&type=template&id=476a78d6"
import script from "./RatingDialog.vue?vue&type=script&lang=js"
export * from "./RatingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports